import React from 'react'
import { useAppSelector } from '../../redux/hooks'
import LoginModal from '../Modals/LoginModal/LoginModal'
import SplashModal from '../Modals/SplashModal/SplashModal'
import { RootState } from '../../redux/store'
import { ModalType } from '../../core/enums/Modals'
import UserModal from './UserModal/UserModal'
import InboxModal from './InboxModal/InboxModal'
import BalanceModal from './BalanceModal/BalanceModal'
import CashierModal from './CashierModal/CashierModal'
import { EventName } from '../../core/enums/moneyOperations'

interface ModalManagerProps {
	onSubmit: (eventName?: EventName, eventData?: any, close?: boolean) => void
}

export const ModalCssAnimation = 'modalAppear';

export default function ModalManager({ onSubmit }: ModalManagerProps) {
	const { activeModal, modalProps } = useAppSelector((state: RootState) => state.modal)

	switch (activeModal) {
		case ModalType.Login:
			return (
				<div className="modal-background">
					<LoginModal />
				</div>
			)
		case ModalType.Splash:
			return (
				<div className="modal-background">
					<SplashModal />
				</div>
			)
		case ModalType.Cashier:
			return (
				<div className="modal-background">
					<CashierModal
						initialTab={modalProps?.initialTab || 'deposit'}
						onSubmit={onSubmit}
					/>
				</div>
			)
		case ModalType.User:
			return <UserModal {...modalProps} />
		case ModalType.Balance:
			return <BalanceModal {...modalProps} />
		case ModalType.Inbox:
			return <InboxModal {...modalProps} />
		default:
			return null
	}
}
